import { render, staticRenderFns } from "./CreditCustomersAdvance.vue?vue&type=template&id=2939615a&scoped=true&"
import script from "./CreditCustomersAdvance.vue?vue&type=script&lang=js&"
export * from "./CreditCustomersAdvance.vue?vue&type=script&lang=js&"
import style0 from "./CreditCustomersAdvance.vue?vue&type=style&index=0&id=2939615a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939615a",
  null
  
)

export default component.exports